import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

import { useCurrentUserQuery } from '@/modules/users/queries/useCurrentUserQuery';
import { isLocalEnv } from '@/utils/env';

// This hook is the main place a signed-in user's email reaches client tooling.
// Send it to PostHog only; never console.log it or another debug sink — it is
// production PII.
export const useIdentifyUser = () => {
  const posthog = usePostHog();
  const currentUserQuery = useCurrentUserQuery();

  useEffect(() => {
    if (!currentUserQuery.data) {
      return;
    }

    if (!isLocalEnv) {
      posthog.identify(currentUserQuery.data.id, {
        email: currentUserQuery.data.email,
        // Groups people by company before they name it in onboarding.
        emailDomain: currentUserQuery.data.email?.split('@')[1],
        name: `${currentUserQuery.data.firstName} ${currentUserQuery.data.lastName}`,
        tenantIds: currentUserQuery.data.tenantIds,
      });
    }

    // Keep feature-flag conditions based on user email working in localhost.
    posthog.setPersonPropertiesForFlags({
      email: currentUserQuery.data.email,
    });
  }, [currentUserQuery.data, posthog]);
};
